<template>
  <span/>
</template>

<script>
import XlsxMixin from "../../../mixins/XlsxMixin.js";
import Catalog from "../StrdCatalog.js";
import Info from "../StrdInfo.js";
import Model from "../StrdModel.js";
import StrdItemCatalog from "../StrdItemCatalog.js";

export default {
  mixins: [XlsxMixin],
  props: {
    access: Object,
    userData: Object
  },
  created() {
    this.$emit(this.$kst.Enum.Event.Init, this.exportExcel);
  },
  methods: {
    exportExcel(data, fileName) {
      this.createBook();
      this.createSheet();

      this.addList(data.List);

      this.download(fileName);
    },

    addList(dataList) {
      // label
      this.addColumnHeader_ID();
      this.addColumnHeader(Catalog.ReductionNumber);
      this.addColumnHeader(Catalog.Date);
      this.addColumnHeader_ID(Catalog.WarehouseID.Label);
      this.addColumnHeader(Catalog.WarehouseID);
      this.addColumnHeader_ID(Catalog.TransactionID.Label);
      this.addColumnHeader(Catalog.TransactionID);
      this.addColumnHeader(Catalog.Total);

      if (this.userData.WithItems) {
        this.addColumnHeader_ID(StrdItemCatalog.DispatchID.Label);
        this.addColumnHeader(StrdItemCatalog.DispatchID);
        this.addColumnHeader(StrdItemCatalog.Packaging);
        this.addColumnHeader(StrdItemCatalog.Qty);
        this.addColumnHeader(StrdItemCatalog.TotalQty);
        this.addColumnHeader_ID(StrdItemCatalog.SpecialPriceID.Label);
        this.addColumnHeader(StrdItemCatalog.SpecialPriceID);
        this.addColumnHeader(StrdItemCatalog.SpecialPriceDiscPercent);
        this.addColumnHeader(StrdItemCatalog.SellPrice);
        this.addColumnHeader(StrdItemCatalog.Total);
        if (this.access.Glob_HPP) {
          this.addColumnHeader(StrdItemCatalog.HppTotal);
        }
      }

      // value
      for (const row of dataList) {
        this.addRow();

        this.addCellValue_ID(row);
        this.addCellValue("ReductionNumber", row, Catalog);
        this.addCellValue("Date", row, Catalog);
        this.addCellValue("WarehouseID", row, Catalog);
        this.addCellRelatedValue("WarehouseID", row, Catalog);
        this.addCellValue("TransactionID", row, Catalog);
        this.addCellRelatedValue("TransactionID", row, Catalog);
        this.addCellValue("Total", row, Catalog);

        if (this.userData.WithItems) {
          Model.updateItemReadOnly(row);

          this.addCellValue("DispatchID", row, StrdItemCatalog);
          this.addCellRelatedValue("DispatchID", row, StrdItemCatalog);
          this.addCellValue("Packaging", row, StrdItemCatalog);
          this.addCellValue("Qty", row, StrdItemCatalog);
          this.addCellValue("TotalQty", row, StrdItemCatalog);
          this.addCellValue("SpecialPriceID", row, StrdItemCatalog);
          this.addCellRelatedValue("SpecialPriceID", row, StrdItemCatalog);
          this.addCellValue("SpecialPriceDiscPercent", row, StrdItemCatalog);
          this.addCellValue("SellPrice", row, StrdItemCatalog);
          this.addCellValue("Total", row, StrdItemCatalog);
          if (this.access.Glob_HPP) {
            this.addCellValue("HppTotal", row, StrdItemCatalog);
          }
        }
      }

      this.addSheet(Info.Export.List.Excel.SheetName.List);
    }
  }
}
</script>